import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/svg/googleplay.svg?url")